import React from 'react';
import { TProject } from '@frontend/app/containers/Projects/types';
import { IColumn } from '@frontend/app/types/Columns';
import { MemberFieldSchemasQuery_schemas } from '@frontend/app/queries/types/MemberFieldSchemasQuery';

const createColumnFromField = (field: MemberFieldSchemasQuery_schemas) => ({
  id: field.id.toString(),
  accessorKey: field.id.toString(),
  header: () => (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-foreground">{field.name}</span>
    </div>
  ),
  cell: ({ row }) => {
    return <div>{row.original[field.id]}</div>;
  },
  size: 250,
});

const processTemplateFields = (
  templateColumns: Array<{ label: string }> | undefined,
  memberFieldSchemas: MemberFieldSchemasQuery_schemas[],
  existingColumns: IColumn[]
) => {
  const result = [];
  templateColumns?.forEach((column) => {
    if (!existingColumns.find((c) => c.headerName === column.label)) {
      const field = memberFieldSchemas.find((f) => f.name === column.label);
      if (field) {
        result.push(createColumnFromField(field));
      }
    }
  });
  return result;
};

export const createApplicationTemplateColumns = (project: TProject, columns: IColumn[], memberFieldSchemas: MemberFieldSchemasQuery_schemas[]) => {
  const result = [];

  project?.onboardingTemplates.forEach((template) => {
    const amplifyTemplate = template?.config?.amplifyTemplate;
    const pulseTemplate = template?.config?.pulseTemplate;

    // Process amplify template fields
    if (amplifyTemplate) {
      const templateColumns = amplifyTemplate?.pages?.[0]?.home?.forms?.applicationFormFields?.memberFieldSchemas;
      const extendedColumns = amplifyTemplate?.pages?.find((page) => page?.forms)?.forms?.applicationFormFields?.memberFieldSchemas;
      const allColumns = [
        ...(templateColumns || []),
        ...(extendedColumns || [])
      ];
      const amplifyColumns = processTemplateFields(allColumns, memberFieldSchemas, columns);
      result.push(...amplifyColumns);
    }

    // Process pulse template fields
    if (pulseTemplate) {
      const pulseTemplateColumns = pulseTemplate.pages?.[0]?.hero?.applicationFormFields?.memberFieldSchemas;
      const extendedColumns = pulseTemplate?.pages?.find((page) => page?.forms)?.forms?.applicationFormFields?.memberFieldSchemas;
      const allColumns = [
        ...(pulseTemplateColumns || []),
        ...(extendedColumns || [])
      ];
      const pulseColumns = processTemplateFields(allColumns, memberFieldSchemas, columns);
      result.push(...pulseColumns);
    }
  });

  return result;
};
